import { makeRootStyles } from "../../../theme/styles";

const useStyles = makeRootStyles(
  {
    selectList: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    selectListOption: {
      padding: "0.875rem 1rem",
      fontSize: "14px",
      flexGrow: 1,
      textAlign: "start",
      fontWeight: "inherit",
      margin: 0,
    },
  },
  {
    name: "N0SelectList",
  },
);

export { useStyles };
